import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { daiWebhooks } from '../../docs-routes'

const WebhookHelp = () =>
  <div className='grid gap-4'>
    <div className='grid gap-3'>
      <Header
        hasNoTopMargin
        lessWeight
        rank={3}
      >
        Webhook
      </Header>
      <Paragraph>
        <strong>
          <Color variant='theme-description-text'>
            You can use Webhooks to trigger a wide range of notifications when a test config run finishes.
            <br />
            <br />
            DAI Admins can create, view, and manage webhook profiles here.
            <br />
          </Color>
        </strong>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToDocusaurus path={daiWebhooks}>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </Paragraph>
  </div>

export default WebhookHelp
